import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ParticipantService {

  private _baseUrl : string = "";
  private _controllerName :string = "";

  constructor(private _http : HttpClient) {
    this._baseUrl = environment.apiUrl;
    this._controllerName = "Participant"
  }

  // private getHeaders(): HttpHeaders{
  //   return new HttpHeaders({
  //     'Content-Type': 'application/json',
  //     'Authorization': `Bearer ${this.getToken()}`
  //   })
  // }

  insert(payload: any): Observable<any>{
    return this._http.post<any>(`${this._baseUrl}/${this._controllerName}`, payload).pipe(catchError(this.handleErrors))
  }

  update(id:number,payload: any): Observable<any>{
    return this._http.put<any>(`${this._baseUrl}/${this._controllerName}/${id}`, payload).pipe(catchError(this.handleErrors))
  }

  delete(id:number): Observable<any>{
    return this._http.delete<any>(`${this._baseUrl}/${this._controllerName}/${id}`).pipe(catchError(this.handleErrors))
  }

  getAll(): Observable<any>{
    return this._http.get<any>(`${this._baseUrl}/${this._controllerName}/`).pipe(catchError(this.handleErrors))
  }

  getAllFiltered(searchTerm?: string, status?: string | number): Observable<any>{
    let params: any = {};
    if (searchTerm && searchTerm.trim() !== '') {
      params.searchTerm = searchTerm.trim();
    }
    if (status !== null && status !== undefined && status !== '') {
      // If it's a number (enum value), use it directly. If it's a string, parse it
      const statusValue = typeof status === 'number' ? status : parseInt(status.toString(), 10);
      if (!isNaN(statusValue)) {
        params.status = statusValue;
      }
    }
    
    const queryString = Object.keys(params).length > 0 ? '?' + Object.keys(params).map(key => `${key}=${encodeURIComponent(params[key])}`).join('&') : '';
    return this._http.get<any>(`${this._baseUrl}/${this._controllerName}/${queryString}`).pipe(catchError(this.handleErrors))
  }

  getPaged(pageNumber: number = 1, pageSize: number = 20, searchTerm?: string, status?: string | number): Observable<any> {
    let params: any = {
      pageNumber: pageNumber,
      pageSize: pageSize
    };
    
    if (searchTerm && searchTerm.trim() !== '') {
      params.searchTerm = searchTerm.trim();
    }
    
    if (status !== null && status !== undefined && status !== '') {
      const statusValue = typeof status === 'number' ? status : parseInt(status.toString(), 10);
      if (!isNaN(statusValue)) {
        params.status = statusValue;
      }
    }
    
    const queryString = Object.keys(params).map(key => `${key}=${encodeURIComponent(params[key])}`).join('&');
    return this._http.get<any>(`${this._baseUrl}/${this._controllerName}?${queryString}`).pipe(catchError(this.handleErrors));
  }

  getById(id: number): Observable<any>{
    return this._http.get<any>(`${this._baseUrl}/${this._controllerName}/${id}`).pipe(catchError(this.handleErrors))
  }

  getProfile(id: number): Observable<any>{
    return this._http.get<any>(`${this._baseUrl}/${this._controllerName}/${id}/profile`).pipe(catchError(this.handleErrors))
  }

  private handleErrors(error: HttpErrorResponse){
    if(error.error instanceof ErrorEvent){
      console.log("Ocurrio un error", error.error.message);
    }else{
      console.log(`Ocurrio un error ${error.status}, ${error.error}`);
    }
    return throwError(() => new Error('Algo salió mal; por favor, intente nuevamente más tarde.'));
  }
}
